import React, { Component } from 'react';

class ClickAwayListener extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();  // Crear un ref
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickAway);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickAway);
  }

  handleClickAway = (event) => {
    if (!this.node.current) return;  // Usar ref actual
    if (!this.node.current.contains(event.target)) {
      this.props.onClickAway(event);  // Llamar a `onClickAway` si no se hizo clic dentro del nodo
    }
  };

  render() {
    return <div ref={this.node}>{this.props.children}</div>;  // Asignar el ref al div que envuelve los children
  }
}

export default ClickAwayListener;
